import { MAX_QUOTE_PROPERTIES, perVideoCents, quoteTotalCents } from "../lib/pricing";
import { api, messageOf } from "./lib/api";
import { $, formatMoney, show } from "./lib/dom";

// The base price is the same one the server charges (PRICE_CENTS); the quote form only estimates.
const BASE_CENTS = 15000;

const dialog = $<HTMLDialogElement>("#quote-dialog");
const form = $<HTMLFormElement>("#quote-form");
const countInput = $<HTMLInputElement>("#quote-properties");
const estimate = $("#quote-estimate");
const error = $("#quote-error");
const sent = $("#quote-sent");

function count(): number | null {
  const n = Number(countInput.value);
  return Number.isInteger(n) && n >= 2 && n <= MAX_QUOTE_PROPERTIES ? n : null;
}

function updateEstimate(): void {
  const n = count();
  estimate.textContent =
    n === null
      ? `Enter a number from 2 to ${MAX_QUOTE_PROPERTIES}.`
      : `${formatMoney(perVideoCents(n, BASE_CENTS), "usd")} per video, ${formatMoney(quoteTotalCents(n, BASE_CENTS), "usd")} for ${n} properties.`;
}

function open(): void {
  updateEstimate();
  dialog.showModal();
  countInput.focus();
  countInput.select();
}

for (const button of document.querySelectorAll("[data-open-quote]")) button.addEventListener("click", open);
$("#quote-close").addEventListener("click", () => dialog.close());
dialog.addEventListener("click", (event) => {
  if (event.target === dialog) dialog.close(); // a click on the backdrop
});
countInput.addEventListener("input", updateEstimate);
if (location.hash === "#quote") open();

form.addEventListener("submit", async (event) => {
  event.preventDefault();
  show(error, false);
  const properties = count();
  const data = new FormData(form);
  const email = String(data.get("email") ?? "").trim();
  if (properties === null) {
    error.textContent = `Enter a number of properties from 2 to ${MAX_QUOTE_PROPERTIES}.`;
    show(error);
    countInput.focus();
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    error.textContent = "Enter a valid email address.";
    show(error);
    $<HTMLInputElement>("#quote-email").focus();
    return;
  }
  const button = form.querySelector<HTMLButtonElement>("button[type=submit]");
  if (button) button.disabled = true;
  try {
    const { message } = await api<{ message: string }>("/api/quote", {
      json: { properties, email, name: String(data.get("name") ?? ""), message: String(data.get("message") ?? "") },
    });
    sent.textContent = message;
    show(form, false);
    show(sent);
  } catch (err) {
    error.textContent = messageOf(err);
    show(error);
  } finally {
    if (button) button.disabled = false;
  }
});
